document.addEventListener("DOMContentLoaded", function () {
  const swipers = document.querySelectorAll(".cr-swiper");

  swipers.forEach(function (swiperEl) {
    const slides = parseInt(swiperEl.dataset.slides) || 3;

    new Swiper(swiperEl, {
      loop: true,
      spaceBetween: 20,
      navigation: {
        nextEl: swiperEl.querySelector(".swiper-button-next"),
        prevEl: swiperEl.querySelector(".swiper-button-prev")
      },
      pagination: {
        el: swiperEl.querySelector(".swiper-pagination"),
        clickable: true
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          slidesPerGroup: 1
        },
        768: {
          slidesPerView: 2,
          slidesPerGroup: 2
        },
        1024: {
          slidesPerView: slides,
          slidesPerGroup: slides
        }
      }
    });
  });
});
